import { CommonApiService } from "./../../services/common-api.service";
import { Component, OnInit, ElementRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  Location,
  LocationStrategy,
  PathLocationStrategy,
} from "@angular/common";
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from "src/environments/environment";
import { UserProfileComponent } from "../user-profile/user-profile.component";
import { first } from "rxjs/operators";
declare interface RouteInfo {
  path: string;
  title: string;
}

export const ROUTES: RouteInfo[] = [
  { path: "/dashboard", title: "" },
  { path: "/analysis", title: "Analysis" },
  { path: "/budget", title: "Budget" },
  { path: "/user-profile", title: "My Profile" },
  { path: "/vyas", title: "Vyas" },
  { path: "/add-appliance", title: "Add Device" },
  { path: "/referral", title: "Referral" },
  { path: "/support", title: "Support" },
  { path: "/more", title: "More" },
  { path: "/train-bot", title: "Train your bot" },
];

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit {
  public menuItems: any[];
  public location: Location;
  titlee: any;
  version: any;
  profile: any;
  constructor(
    location: Location,
    private element: ElementRef,
    public router: Router,
    public afAuth: AngularFireAuth,
    public api: CommonApiService
  ) {}

  ngOnInit(): void {
    this.version = environment.version;
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
    this.getCurrentUser();
  }

  getCurrentUser() {
    this.api
      .getUserData()
      .pipe(first())
      .subscribe((res) => {
        this.profile = res;
      });
  }

  getTitle() {
    for (var item = 0; item < this.menuItems.length; item++) {
      if (this.menuItems[item].path === this.router.url) {
        return this.menuItems[item].title;
      }
    }
    return "login";
  }

  logout() {
    this.afAuth.signOut();
    localStorage.clear();
    this.router.navigate(["/login"]);
    localStorage.removeItem("user");
  }

  openNav() {
    // document.getElementById("mySidenav").style.width = "320px";
    document.getElementById("mySidenav").classList.add("mySidenav");
    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    document.getElementById("overlay").style.display = "block";
    // document.getElementById("main").style.marginRight = "250px";
  }

  closeNav() {
    document.getElementById("mySidenav").classList.remove("mySidenav");
    document.body.style.backgroundColor = "white";
    document.getElementById("overlay").style.display = "none";
    // document.getElementById("main").style.marginRight= "0";
  }
}
